/*********************************************************************
* © Copyright IBM Corp. 2024
*********************************************************************/
import {Popover} from '@targetprocess/popover'
import React, {useState} from 'react'
import classNames from 'classnames'
import styles from '../style/index.css'

export type FilterHeaderItem = {
  id: string
  displayName: string
}

export type DropdownListFilterHeaderProps = {
  currentValue: FilterHeaderItem | null
  options: FilterHeaderItem[]
  onCurrentValueChange: (item: FilterHeaderItem | null) => void
  popoverZIndex?: number
  title?: string
  defaultValueText: string
}

export const DropdownListFilterHeader = ({
  currentValue,
  options,
  onCurrentValueChange,
  defaultValueText,
  title,
  popoverZIndex
}: DropdownListFilterHeaderProps) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false)

  const hasOptions = options && options.length > 0
  const currentValueText = currentValue?.displayName ?? defaultValueText
  const isActiveHeader = currentValue != null
  const hasFilter = currentValueText !== defaultValueText
  return hasOptions ? (
    <Popover
      zIndex={popoverZIndex}
      getPopoverPosition={'bottomLeft'}
      isOpen={isPopoverOpen}
      body={
        <Popover.Body noPadding>
          <div className={classNames(styles['popover'])}>
            <div
              className={classNames(styles['popover__item'])}
              onClick={() => {
                // tslint:disable-next-line
                onCurrentValueChange && onCurrentValueChange(null)
                setIsPopoverOpen(false)
              }}
            >
              {defaultValueText}
            </div>
            {options &&
              options.map(serviceOption => (
                <div
                  className={classNames(styles['popover__item'])}
                  onClick={() => {
                    // tslint:disable-next-line
                    onCurrentValueChange && onCurrentValueChange(serviceOption)
                    setIsPopoverOpen(false)
                  }}
                  key={serviceOption.id}
                >
                  {serviceOption.displayName}
                </div>
              ))}
          </div>
        </Popover.Body>
      }
    >
      <div className={classNames(styles['log__header'])}>
        <div
          className={classNames(
            [
              styles['log__header__name'],
              isActiveHeader && styles['log__header__name--active']
            ].join(' ')
          )}
          onClick={() => setIsPopoverOpen(!isPopoverOpen)}
        >
          {title || defaultValueText}
          {hasFilter ? <span className={styles['log__header__name__two-dots']}>:</span> : null}
          {hasFilter ? (
            <span className={styles['log__header__name__current-filter']}>{currentValueText}</span>
          ) : null}
        </div>
      </div>
    </Popover>
  ) : (
    <div className={classNames(styles['log__header'])}>
      <div
        className={classNames(
          [
            styles['log__header__name'],
            styles['log__header__name--disabled'],
            isActiveHeader && styles['log__header__name--active']
          ].join(' ')
        )}
        onClick={() => setIsPopoverOpen(!isPopoverOpen)}
      >
        {currentValueText}
      </div>
    </div>
  )
}
